import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Category } from '@generated/base-types';
import { AggregateLocalisationPipe } from '@new/common/pipes/aggregate-localisation.pipe';
import { CopyArrayPipe } from '@new/common/pipes/copy-array.pipe';
import { LocalizeContentPipe } from '@new/common/pipes/localize-content.pipe';
import { TableModule } from 'primeng/table';

@Component({
  selector: 'man-category-table',
  templateUrl: './category-table.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    TableModule,
    CopyArrayPipe,
    LocalizeContentPipe,
    AggregateLocalisationPipe
  ]
})
export class CategoryTableComponent {
  @Input() public categories: Category[] = [];
}
